import type { StateCreator } from 'zustand';

export type Routes =
  | 'chat'
  | 'initial'
  | 'threads'
  | 'signIn'
  | 'settings'
  | 'newMembership'
  | 'newMembershipConsent'
  | 'newMembershipRecap'
  | 'membershipPayment'
  | 'pauseMembership'
  | 'groupClasses'
  | 'groupClassDetail';

export interface RouterSlice {
  route: Routes;
  routeData: any;
  history: [Routes, any][];
  pushRoute: (route: Routes, routeData?: any) => void;
  popRoute: () => void;
}

export const createRouterSlice: StateCreator<RouterSlice> = set => ({
  history: [],
  route: 'initial',
  routeData: null,
  pushRoute: (route: Routes, routeData?: any) =>
    set(state => ({
      history: [...state.history, [state.route, state.routeData]],
      route,
      routeData: routeData ?? null,
    })),
  popRoute: () =>
    set(state => {
      const history = [...state.history];
      const previousState = history.pop();

      const route = previousState?.[0] ?? 'initial';
      const routeData = previousState?.[1] ?? null;

      return { history, route, routeData };
    }),
});
